.hearhub-logo{width:142px;height:51.55px}
/*# sourceMappingURL=hearhub-logo.component-KN2S4VZR.css.map */
